import { createSelector } from 'reselect';
// Import state types.
import {
	AppState,
	ProducerSignupState,
} from '@app/redux/states';
// Import api models.
import {
	PossibleBusinessType,
	PossibleHeardThroughOption,
	PossibleMasterProducer,
} from '@app/models/api';

// Fetches the producer signup state.
const getProducerSignupState = (state: AppState): ProducerSignupState => {
	return state.producerSignup;
}

// get possible heard through options selector
const makeGetPossibleHeardThroughOptionsSelector = () => createSelector(
	[getProducerSignupState],
	(producerSignupState: ProducerSignupState): PossibleHeardThroughOption[] => {
		return producerSignupState.heardThroughOptions;
	}
);

// are possible heard through options loaded selector
const makeArePossibleHeardThroughOptionsLoadedSelector = () => createSelector(
	[getProducerSignupState],
	(producerSignupState: ProducerSignupState): boolean => {
		return producerSignupState.areHeardThroughOptionsLoaded;
	}
);

// are possible business types loaded selector
const makeArePossibleBusinessTypesLoadedSelector = () => createSelector(
	[getProducerSignupState],
	(producerSignupState: ProducerSignupState): boolean => {
		return producerSignupState.arePossibleBusinessTypesLoaded;
	}
);

// get possible business types selector
const makeGetPossibleBusinessTypesSelector = () => createSelector(
	[getProducerSignupState],
	(producerSignupState: ProducerSignupState): PossibleBusinessType[] => {
		return producerSignupState.possibleBusinessTypes;
	}
);

//get possible master producers selector
const makeGetPossibleMasterProducersSelector = () => createSelector(
	[getProducerSignupState],
	(producerSignupState: ProducerSignupState): PossibleMasterProducer[] => {
		return producerSignupState.possibleMasterProducers;
	}
);

// are possible master producers loaded selector
const makeArePossibleMasterProducersLoadedSelector = () => createSelector(
	[getProducerSignupState],
	(producerSignupState: ProducerSignupState): boolean => {
		return producerSignupState.arePossibleMasterProducersLoaded;
	}
);

// Export base selectors.
export {
	getProducerSignupState
};

// export selectors.
export {
	makeGetPossibleHeardThroughOptionsSelector,
	makeArePossibleHeardThroughOptionsLoadedSelector,
	makeGetPossibleBusinessTypesSelector,
	makeArePossibleBusinessTypesLoadedSelector,
	makeGetPossibleMasterProducersSelector,
	makeArePossibleMasterProducersLoadedSelector,
};